import { Dialog } from 'radix-ui';
import './privacy_policy.css';
import { CrossIcon } from '../../../assets/icons.tsx';

function PrivacyPolicy() {
    return (
        <Dialog.Root>
            <Dialog.Trigger asChild>
                <button type="button" className="footer__button">
                    Privacy policy
                </button>
            </Dialog.Trigger>
            <Dialog.Portal>
                <Dialog.Overlay className="privacy_policy__overlay" />
                <Dialog.Content className="privacy_policy__dialog">
                    <Dialog.Title>Privacy policy</Dialog.Title>
                    <Dialog.Description className="privacy_policy__dialog__body">
                        <p>
                            The use of Services (by Sensirion AG) requires
                            processing of company and/or personal data.
                            Sensirion collects and maintains personal data of
                            clients, suppliers, and other business partners and
                            of people who work for them, or of people who
                            provide us with business cards or other contact
                            information, of people who use our contact form, of
                            job applicants, employees, contractors, and
                            investors. If the processing of personal data is
                            necessary, we rely on one or more of the following
                            processing conditions: to satisfy any legal and
                            regulatory obligations to which we are subject; our
                            legitimate interests in the effective delivery of
                            products, information and services to you or the
                            company you work for and in the effective and lawful
                            operation of our business (provided these do not
                            interfere with your rights); to perform our
                            obligations under a contract with you or the company
                            you work for; or where no other condition for
                            processing is available, if you have given us
                            consent to process your personal data for the
                            relevant purpose. The processing of personal data,
                            such as the name, job title, company name, address,
                            e-mail address, telephone number, or fax number of a
                            data subject shall always be in line with the
                            General Data Protection Regulation (GDPR), and in
                            accordance with the country-specific data protection
                            regulations applicable to Sensirion AG. By means of
                            this data protection declaration, our enterprise
                            would like to inform the general public of the
                            nature, scope, and purpose of the personal data we
                            collect, use and process. Furthermore, data subjects
                            are informed, by means of this data protection
                            declaration, of the rights to which they are
                            entitled. As the controller, Sensirion AG has
                            implemented numerous technical and organizational
                            measures to protect personal data from loss, misuse,
                            alteration or destruction. Although we use
                            appropriate security measures once we have received
                            your personal data, the transmission of data over
                            the internet (including by e-mail) is never
                            completely secure. We endeavor to protect personal
                            data, but we cannot guarantee the security of data
                            transmitted to or by us. Internet-based data
                            transmissions may in principle have security gaps,
                            so absolute protection may not be guaranteed. For
                            further information kindly refer to{' '}
                            <a href="https://sensirion.com/legal-notice/">
                                https://sensirion.com/legal-notice/
                            </a>
                            .
                        </p>
                        <p>
                            For information on our use of cookies, please refer
                            to:
                            <a href="https://sensirion.com/legal-notice/cookie-policy/">
                                https://sensirion.com/legal-notice/cookie-policy/
                            </a>
                            .
                        </p>
                        <p>
                            In case neither the above, nor the linked further
                            information provides the desired answers, kindly
                            reach out to Sensirion under privacy@sensirion.com,
                            or reach Sensirion at:
                        </p>
                        <p>
                            Sensirion AG
                            <br />
                            Laubisrütistrasse 50
                            <br />
                            CH-8712 Staefa ZH
                            <br />
                            Switzerland
                        </p>
                    </Dialog.Description>

                    <Dialog.Close asChild>
                        <button
                            className="privacy_policy__close_button"
                            aria-label="Close"
                        >
                            <CrossIcon />
                        </button>
                    </Dialog.Close>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
}

export default PrivacyPolicy;
